export default __webpack_public_path__ + "static/media/03.2a5f3eed.jpg";